export const isDefine = (element: any): boolean => element !== undefined && element !== null;

export const isNullOrUndefined = (element: any): boolean => !isDefine(element);

export const isPositiveNumber = (element: number): boolean => isDefine(element) && element >= 0;
